import React, {Component} from "react";
import {DashboardSingleValueCell} from "../base/DashboardSingleValueCell";

export class DashboardFullPeriodODSCell extends Component {
    render() {
        return <DashboardSingleValueCell status={this.props.data.status} value={this.props.data.formatted_value} businessUnitId={this.props.businessUnitId} budgetIsNotSet={this.props.data.budget_is_not_set} />;
    }
}
